import { render } from "./CalendarEvent.vue?vue&type=template&id=b5caa1b4&scoped=true"
import script from "./CalendarEvent.vue?vue&type=script&lang=js"
export * from "./CalendarEvent.vue?vue&type=script&lang=js"

import "./CalendarEvent.vue?vue&type=style&index=0&id=b5caa1b4&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5caa1b4"]])

export default __exports__